import { Link } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import moment from "moment";
import "../styles/homepage/Hero.scss";
import { PublicEventAPI } from "../services/publicEvent.api";

// Mosaic fallback (jika tidak ada event upcoming)
const MOSAIC = [
  {
    url: "https://images.unsplash.com/photo-1507692049790-de58290a4334?w=600&q=80",
    alt: "Paduan suara gereja",
  },
  {
    url: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=600&q=80",
    alt: "Pertunjukan musik ibadah",
  },
  {
    url: "https://images.unsplash.com/photo-1519491050282-cf00c82424b1?w=600&q=80",
    alt: "Ibadah komunitas gereja",
  },
];

function getStats(event) {
  const total =
    event.ticketTiers?.reduce((sum, t) => sum + Number(t.quota || 0), 0) || 0;
  const sold = typeof event.sold === "number" ? event.sold : 0;
  const remaining =
    typeof event.remaining === "number"
      ? event.remaining
      : Math.max(total - sold, 0);
  const percent =
    typeof event.percent === "number"
      ? event.percent
      : total > 0
      ? Math.round((sold / total) * 100)
      : 0;
  const minPrice =
    event.ticketTiers?.length > 0
      ? Math.min(...event.ticketTiers.map((t) => t.price))
      : 0;
  return { remaining, minPrice, percent, total };
}

function getCountdown(date) {
  const diff = new Date(date) - new Date();
  if (diff <= 0) return null;
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s };
}

function pad(n) {
  return String(n).padStart(2, "0");
}

export default function Hero() {
  const [featured, setFeatured] = useState(null);
  const [countdown, setCountdown] = useState(null);

  const fetchFeatured = useCallback(async () => {
    try {
      const res = await PublicEventAPI.list();
      const data = res.data;
      if (!data?.length) return;

      const now = moment();
      const upcoming = data
        .filter((e) => moment(e.date).isSameOrAfter(now, "day"))
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      if (upcoming.length > 0) setFeatured(upcoming[0]);
    } catch {
      // silently ignore; mosaic fallback will show
    }
  }, []);

  useEffect(() => {
    fetchFeatured();
  }, [fetchFeatured]);

  useEffect(() => {
    if (!featured) return;
    const tick = () => setCountdown(getCountdown(featured.date));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [featured]);

  const stats = featured ? getStats(featured) : null;
  const image =
    featured?.headerImage?.url ||
    "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=900";

  return (
    <section className="hero" id="home">
      <div className="hero-container">
        {/* ── Text ──────────────────────────────── */}
        <div className="hero-left">
          <span className="hero-label">RTC</span>

          <h1>
            RoundTable<br />
            Community
            {/* Community &amp; <em>Ibadah</em> */}
          </h1>

          <p className="hero-sub">
            RTC adalah komunitas pria dari GKY Greenville sebagai wadah untuk bertumbuh bersama, berbagi, kesaksian, saling menguatkan, dan diperlengkapi menjadi pemimpin dalam keluarga, gereja, serta komunitas.
          </p>

          {/* <div className="hero-ctas">
            <Link to="/events" className="btn btn-full cta-primary">
              Lihat Event
            </Link>
            {/* <a href="#about" className="cta-ghost">
              Tentang RTC
            </a>
          </div> */}

          {/* <div className="hero-trust">
            <span>Resmi GKY Sinode</span>
            <span className="trust-dot" />
            <span>Tiket Digital</span>
            <span className="trust-dot" />
            <span>Tanpa Daftar Akun</span>
          </div> */}
        </div>

        {/* ── Featured Event / Mosaic Fallback ─── */}
        {featured ? (
          <div className="hero-featured">
            <div className="hf-badge">Event Terdekat</div>

            <div className="hf-image">
              <img src={image} alt={featured.title} loading="lazy" />
            </div>

            <div className="hf-body">
              <h3 className="hf-title">{featured.title}</h3>

              <div className="hf-meta">
                <span className="hf-meta-icon">📅</span>
                {moment(featured.date).format("D MMMM YYYY")}
                {(featured.timeStart || featured.timeEnd) && (
                  <> &middot; {featured.timeStart}{featured.timeEnd ? `–${featured.timeEnd}` : ""}</>
                )}
                {featured.location?.name && (
                  <> &middot; {featured.location.name}</>
                )}
              </div>

              {countdown && (
                <div className="hf-countdown">
                  <div className="hf-countdown-label">Mulai dalam</div>
                  <div className="hf-countdown-grid">
                    <div className="hf-unit">
                      <span className="hf-num">{pad(countdown.d)}</span>
                      <span className="hf-lbl">hari</span>
                    </div>
                    <div className="hf-sep">:</div>
                    <div className="hf-unit">
                      <span className="hf-num">{pad(countdown.h)}</span>
                      <span className="hf-lbl">jam</span>
                    </div>
                    <div className="hf-sep">:</div>
                    <div className="hf-unit">
                      <span className="hf-num">{pad(countdown.m)}</span>
                      <span className="hf-lbl">menit</span>
                    </div>
                    <div className="hf-sep">:</div>
                    <div className="hf-unit">
                      <span className="hf-num">{pad(countdown.s)}</span>
                      <span className="hf-lbl">detik</span>
                    </div>
                  </div>
                </div>
              )}

              {/* {stats && (
                <div className="hf-tickets">
                  <div className="hf-progress-bar">
                    <div
                      className="hf-progress-fill"
                      style={{ width: `${Math.min(stats.percent, 100)}%` }}
                    />
                  </div>
                  <div className="hf-progress-info">
                    <span className="hf-remaining">
                      {stats.remaining} tiket tersisa
                    </span>
                    <span className="hf-percent">{stats.percent}% terjual</span>
                  </div>
                </div>
              )} */}

              <Link to={`/events/${featured.slug}`} className="hf-cta">
                Lihat Event &rarr;
              </Link>
            </div>
          </div>
        ) : (
          <div className="hero-mosaic">
            {MOSAIC.map((img) => (
              <div key={img.url} className="mosaic-card">
                <img src={img.url} alt={img.alt} loading="lazy" />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
